<template>
	<div style="margin-top:20px;">
		<b-modal id="deliveryListDetailTip" v-model="showDelivery" title="售后列表">
			<b-row align-v="center">
				<b-col lg="12" class="complaintInfo">
                <b-form :model="complainModel" ref="uForm">
					<b-form-group label="售后类型" label-width="180">
						  <b-form-radio v-model="complainModel.complainType" name="1" value="1">数量</b-form-radio>
						  <b-form-radio v-model="complainModel.complainType" name="2" value="2">品质</b-form-radio>
						  <b-form-radio v-model="complainModel.complainType" name="3" value="3">品种</b-form-radio>
						  <b-form-radio v-model="complainModel.complainType" name="4" value="4">其他</b-form-radio>
					</b-form-group>
                    <b-form-group label-width="180" label="详细描述">
                        <b-form-input autocomplete="off" v-model="complainModel.complainInfo" placeholder="填写详细描述"  :border="true" height="100" :auto-height="true" />
                    </b-form-group>
                </b-form>
				</b-col>
			</b-row>
			<template slot="modal-footer">
				<b-button variant="warning"  hover-class="none" @click="onOk()">申请售后</b-button>
			</template>
		</b-modal>
		<div class="info-wrap">
			<table cellspacing="1" width="100%" class="order-info">
				<tr>
					<td>发货单号：{{preSaleDeliveryRecord.billCode}}</td>
				</tr>
				<tr>
					<td>发货单状态：{{preSaleDeliveryRecord.preSaleDeliveryRecordReceivingStatus==1?'已收货':preSaleDeliveryRecord.preSaleDeliveryRecordStatus==1?'已发货':'待发货'}}</td>
				</tr>
				<tr>
					<td>发货日期：{{preSaleDeliveryRecord.sendProductDate}}</td>
				</tr>
				<tr>
					<td>周次：{{preSaleDeliveryRecord.weekSeq+'周（'+preSaleDeliveryRecord.weekBeginDate+'~'+preSaleDeliveryRecord.weekEndDate+'）'}} </td>
				</tr>
				<tr>
					<td>下单时间：{{formatDateTimeString(preSaleDeliveryRecord.preSaleDeliveryRecordCreateAt)}}</td>
				</tr>
				<tr>
					<td>客户账号：{{preSaleDeliveryRecord.userName}}</td>
				</tr>
                <tr>
                	<td>客户名称：{{preSaleDeliveryRecord.userExternalCustomerName}} </td>
                </tr>
                <tr>
                	<td>联系电话：{{preSaleDeliveryRecord.userExternalCustomerContactNumber}} </td>
                </tr>
				<tr>
					<td>收货地址：{{preSaleDeliveryRecord.receiptFullAddress}} </td>
				</tr>
			</table>
		</div>
		<div class="dataTable">
			<b-table id="deliveryDetail-table" :fields="deliveryDetail.fields" :items="deliveryDetail.items" small bordered hover
				:busy="deliveryDetail.isTableBusy" caption-top>
				<template v-slot:cell(index)="row">
					<template v-if="row.item.productCode==''||row.item.productCode=='定金收取(%)'">
						<span></span>
					</template>
					<template v-else>
						  {{ row.index + 1 }}
					</template>
				</template>
				<template v-slot:cell(unitName)="row">
					<template v-if="row.item.unitName=='代金券'">
						<span></span>
					</template>
					<template v-else>
						{{ row.item.unitName }}
					</template>
				</template>
				<template v-slot:cell(additionalQuantity)="row">
					<template v-if="row.item.preSaleDeliveryDetailUuid||row.item.unitName=='数量合计'">
						<span> {{parseFloat(row.item.additionalQuantity)}}</span>
					</template>
					<template v-else>
						  {{row.item.additionalQuantity}}
					</template>
				</template>
				<template v-slot:cell(orderQuantity)="row">
					<template v-if="row.item.preSaleDeliveryDetailUuid||row.item.unitName=='数量合计'">
						<span> {{parseFloat(row.item.orderQuantity)}}</span>
					</template>
					<template v-else>
						  {{row.item.orderQuantity}}
					</template>
				</template>
				<template v-slot:cell(preSalePlanPrice)="row">
					<template v-if="row.item.unitName=='代金券'">
						{{ row.item.unitName }}
					</template>
					<template v-else>
						{{ row.item.preSalePlanPrice }}
					</template>
				</template>
				<template v-slot:cell(totalMoney)="row">
					<template v-if="row.item.unitName=='折扣'||row.item.preSalePlanPrice=='总额'">
						<span> {{parseFloat(row.item.totalMoney.toFixed(2))}}</span>
					</template>
					<template v-else>
						  {{row.item.totalMoney}}
					</template>
				</template>
				<template slot="table-caption">
					<span style="font-weight: bold;">发货单详细信息:{{preSaleDeliveryRecord.sendOrderNo}}</span>
				</template>
				<div slot="table-busy" class="text-center text-info my-2">
					<b-spinner class="align-middle"></b-spinner>
					<strong>加载中...</strong>
				</div>
			</b-table>
		</div>
		<p v-if="preSaleDeliveryRecord.customerMsg != null">客户备注:<strong>{{preSaleDeliveryRecord.customerMsg}}</strong></p>
		<p>备注:如有任何调整或问题请联系你的客户经理<strong>{{preSaleDeliveryRecord.userCustomerManagerName}}</strong></p>
		<div style="width: 100%;text-align: right;padding-bottom: 30px;">
			<template solt="footer-btn">
				<b-button v-if="preSaleDeliveryRecord.preSaleDeliveryRecordStatus==1&&preSaleDeliveryRecord.preSaleDeliveryRecordReceivingStatus==0" variant="success" :pressed="false" v-on:click="updateDelivery(preSaleDeliveryRecord.preSaleDeliveryRecordUuid)">收货</b-button>
				<b-button v-if="preSaleDeliveryRecord.preSaleDeliveryRecordStatus==1&&preSaleDeliveryRecord.hadCompensationRecord==true" variant="warning" :pressed="false" style="color: #fff !important;" v-on:click="complain(preSaleDeliveryRecord.preSaleDeliveryRecordUuid)">申请售后</b-button>
			</template>
		</div>
	</div>
</template>

<script>
	import api from '@/api/api';
	import {
		formatDateTimeString,
		numberToFixed
	} from '@/libs/utils';
	import search from '@/libs/search';
	import "@/style/global.css";
	export default {
		name: 'DeliveryDetails',
		components: {
		},
		data() {
			return {
				showDelivery:false,
				deliveryDetail: {
					fields: [
						{
						    key: "index",
						    label: "序号"
						},
						{
                            key: "productCode",
                            label: "品种编号"
                        },
                        {
                            label: "品种名称",
                            key: "productName"
                        },
						{
						    label: "单位",
						    key: "unitName"
						},
						{
						    label: '发货量',
						    key: 'additionalQuantity'
						},
                        {
                            label: '收款量',
                            key: 'orderQuantity'
                        },

                        {
                            label: '单价',
                            key: 'preSalePlanPrice'
                        },
                        {
                            label: '金额',
                            key: 'totalMoney'
                        }
					],
					items: [],
					isTableBusy: false
				},
                preSaleDeliveryRecord:{},
				preSaleDeliveryRecordUuid:[],
				complainModel: {
					complainOrderUuid: '',
					complainType: 0,
					complainInfo: ''
				}
			};
		},
		mounted() {
			if (!this.checkMemberLogin()) {
				this.$router.push({
					name: 'MemberLogin'
				});
				return;
			};
			if(this.$route.query.preSaleDeliveryRecordUuid){
				this.complainModel.complainOrderUuid=this.$route.query.preSaleDeliveryRecordUuid;
				this.getPreSaleDeliveryRecord(this.$route.query.preSaleDeliveryRecordUuid);
			}
			else if(this.$route.query.preSaleDeliveryRecordUuids){
				let uuids = JSON.parse(decodeURIComponent(this.$route.query.preSaleDeliveryRecordUuids));
				this.complainModel.complainOrderUuid=uuids[0];
				this.getPreSaleDeliveryRecordList(uuids);
			};

		},
		computed: {
		      btnStates() {
		        return this.buttons.map(btn => btn.state)
			}
		},
		methods: {
			formatDateTimeString,
			numberToFixed,
			getPreSaleDeliveryRecord(recordUuidList){
				//获取指定单个发货单
				api.getPreSaleDeliveryRecordList({preSaleDeliveryRecordUuid:recordUuidList,isSign:1}).then(res => {
					if (res.code === 0) {
						const records = res.data.records || res.data.recordList;
						if(records!=null&&records.length>0){
							this.preSaleDeliveryRecord=records[0];
							this.deliveryDetail.items=records[0].orderItmeList;
						}
					}
				});
			},
			getPreSaleDeliveryRecordList(recordUuidList){
				// 获取发货单列表
				api.getPreSaleDeliveryRecordList({preSaleDeliveryRecordUuidList:recordUuidList,isSign:1}).then(res => {
					if (res.code === 0) {
						const records = res.data.records || res.data.recordList;
						if(records!=null&&records.length>0){
							this.preSaleDeliveryRecord=records[0];
							this.deliveryDetail.items=records[0].orderItmeList;
						}
					}
				});
			},
			onOk() {
				// 投诉按钮
				api.addComplain(this.complainModel).then(res => {
					this.showDelivery=false;
					if (res.code === 0) {
						this.$bvModal.msgBoxOk("提交成功!", {
							title: "提示",
							buttonSize: "sm"
						});
					}
				});
			},
			updateDelivery(recordUuid){
				this.$bvModal
					.msgBoxConfirm("是否确认收货？", {
						size: "sm",
						buttonSize: "sm",
						okVariant: "danger",
						okTitle: "是",
						cancelTitle: "否"
					})
					.then(value => {
						this.deliveryDetail.isTableBusy = true;
						api.updatePreSaleDeliveryByUuid({preSaleDeliveryRecordUuid:recordUuid}).then(res => {
							this.deliveryDetail.isTableBusy = false;
							if (res.code === 0) {
								this.$bvModal.msgBoxOk("收货成功!", {
									title: "提示",
									buttonSize: "sm"
								});
								setTimeout(function() {
									window.location.reload();
								}, 1000);
							}
						});
					});
			},
			complain(recordUuid){
				this.showDelivery=true;
			}
		}
	};
</script>

<style>
	.orderKey {
		text-align: right;
		font-size: 14px;
		font-weight: bold;
	}

	.orderValue {
		font-size: 14px;
	}


	/* 信息 */
	.info-wrap {
		width: 100%;
		border: 1px solid #efefef;
		margin: 20px auto;
		background-color: #fafafa;
		padding: 15px 0px;
	}

	.info-wrap .order-info td {
		padding: 5px 30px;
	}

	.info-wrap .order-info td:nth-child(even) {
		color: #a16e02;
	}



	/* 表格 */
	.dataTable {
		margin-top: 20px;
	}

	.dataTable th {
		background-color: #efefef;
		height: 32px;
		line-height: 32px;
	}

	.table.b-table.b-table-caption-top>caption {
		color: #333;
	}

	.table thead th {
		vertical-align: bottom;
		border-bottom: 2px solid #dbdbdb;
        font-size: 14px;
	}

	.table-bordered td,
	.table-bordered th {
		border: 1px solid #dbdbdb;
	}

	.table-sm td,
	.table-sm th {
		padding: 10px 5px;
	}
	.btn-secondary{background-color: #fe7726!important;}


</style>



// WEBPACK FOOTER //
// src/view/delivery-list/delivery-list-details.vue